import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VibrationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"vibration"}/>
}
